import { createContext } from "react";

export const ShopContext = createContext({
  allProducts: null,
});

export default ShopContext;
